import cabinetStyle from "../mentorCabinet/MentorCabinet.module.css";
import Style from "../Style.module.css";
import cardsStyle from "./MetaphoricCardsMentorCabinet.module.css";
import React, {useState} from "react";
import MetaphoricCardsPreviewModal from "./MetaphoricCardsPreviewModal";
import {useTranslation} from "react-i18next";

function MetaphoricCardsStack(props) {
    const [previewOpened, setPreviewOpened] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'metaphoricCardsStack' });

    function getAllCards() {
        let cardsLinks = []
        for (let i = 1; i <= props.numOfCards; i++) {
            cardsLinks.push(props.stackPrefix + i + props.cardExtension)
        }
        return cardsLinks
    }

    function openPreview() {
        setPreviewOpened(true)
    }

    function closePreview() {
        setPreviewOpened(false)
    }

    return (
        <div className={`${cabinetStyle.commonTile} ${cabinetStyle.referralGroup}`} style={{minHeight: "150px", marginTop: "0", marginBottom: "12px"}}>
            <header className={Style.h5Heading}>{props.name}</header>
            <div className={cardsStyle.container}>
                <img src={props.titleLink}
                     onClick={openPreview}
                     alt={"not found"}
                     style={{
                         marginTop: "12px",
                         height: "150px",
                         cursor: "pointer"
                     }}
                ></img>
                <div
                    style={{
                        marginTop: "12px",
                    }}
                >
                    {/*<p>Назва: {props.name}</p>*/}
                    <p>{t('numberOfCards')}: {props.numOfCards}</p>
                    <p>{t('author')}: <a href={props.authorLink} target="_blank">{props.authorName} </a>
                    </p>
                </div>
            </div>
            {previewOpened && <MetaphoricCardsPreviewModal
                name={props.name}
                cardsLinks={getAllCards()}
                onClose={closePreview}
            />}

        </div>
    )
}

export default MetaphoricCardsStack